import React from 'react';
import { InstagramIcon, MailIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function TeamSponsors() {
  const {
    t
  } = useLanguage();
  return <section id="team" className="w-full bg-black py-20 md:py-28 px-4" data-id="element-573">
      <div className="max-w-7xl mx-auto" data-id="element-574">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-575">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-[0.3em] mb-3" data-id="element-576">
            {t('team.peopleBehind')}
          </p>
          <h2 className="font-display text-4xl md:text-6xl tracking-wider text-white mb-4" data-id="element-577">
            {t('team.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-578">
            {t('team.subtitle')}
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-24" data-id="element-579">
          {/* Team Member 1 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden group hover:border-orange-500/30 transition-colors" data-id="element-580">
            <div className="aspect-[4/5] overflow-hidden" data-id="element-581">
              <img src="https://cdn.magicpatterns.com/uploads/ctra39qZYrNduuQnHt7XY3/IMG_0904.jpg" alt="Alekss Jeršovs" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-582" />
            </div>
            <div className="p-5" data-id="element-583">
              <h3 className="font-bold text-white text-lg" data-id="element-584">Alekss Jeršovs</h3>
              <p className="text-orange-500 text-sm font-semibold mb-3" data-id="element-585">
                {t('team.member1Role')}
              </p>
              <p className="text-gray-400 text-sm mb-4" data-id="element-586">
                {'Rekl\u0101mas un dizaina eksperts, kur\u0161 pan\u0101k, lai viss izskat\u0101s tik labi, ka gribas uzreiz pieteikties. Ja nepiesaista uzman\u012Bbu - vi\u0146\u0161 v\u0113l nav pabeidzis.'}
              </p>
              <div className="flex items-center gap-3" data-id="element-587">
                <a href="https://www.instagram.com/vaditajs" target="_blank" className="flex items-center gap-1.5 text-gray-500 hover:text-orange-500 transition-colors" aria-label="Instagram" data-id="element-588">
                  <InstagramIcon className="h-4 w-4" data-id="element-589" />
                  <span className="text-sm" data-id="element-590">vaditajs</span>
                </a>
              </div>
            </div>
          </div>

          {/* Team Member 2 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden group hover:border-orange-500/30 transition-colors" data-id="element-591">
            <div className="aspect-[4/5] overflow-hidden" data-id="element-592">
              <img src="https://cdn.magicpatterns.com/uploads/uGaWSeKULH34KHU85CQ4G8/IMG_3191.jpg" alt="Kalvis Krieviņš" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-593" />
            </div>
            <div className="p-5" data-id="element-594">
              <h3 className="font-bold text-white text-lg" data-id="element-595">Kalvis Krieviņš</h3>
              <p className="text-orange-500 text-sm font-semibold mb-3" data-id="element-596">
                {t('team.member2Role')}
              </p>
              <p className="text-gray-400 text-sm mb-4" data-id="element-597">
                {t('team.member2Desc')}
              </p>
              <div className="flex items-center gap-3" data-id="element-598">
                <a target="_blank" href="https://www.instagram.com/kalviskrievins" className="flex items-center gap-1.5 text-gray-500 hover:text-orange-500 transition-colors" aria-label="Instagram" data-id="element-599">
                  <InstagramIcon className="h-4 w-4" data-id="element-600" />
                  <span className="text-sm" data-id="element-601">kalviskrievins</span>
                </a>
              </div>
            </div>
          </div>

          {/* Team Member 3 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden group hover:border-orange-500/30 transition-colors" data-id="element-602">
            <div className="aspect-[4/5] overflow-hidden" data-id="element-603">
              <img src="https://cdn.magicpatterns.com/uploads/c5VZ8hf3ga3CbaRPax6ehY/PHOTO-2026-03-03-14-59-29.jpg" alt="Raivis Bensons" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" data-id="element-604" />
            </div>
            <div className="p-5" data-id="element-605">
              <h3 className="font-bold text-white text-lg" data-id="element-606">Raivis Bensons</h3>
              <p className="text-orange-500 text-sm font-semibold mb-3" data-id="element-607">
                {t('team.member3Role')}
              </p>
              <p className="text-gray-400 text-sm mb-4" data-id="element-608">
                {'Tas, kur\u0161 zina, kur kas j\u0101paraksta, j\u0101aizpilda un j\u0101iesniedz, lai p\u0101r\u0113jiem par to neb\u016Btu j\u0101dom\u0101.'}
              </p>
              <div className="flex items-center gap-3" data-id="element-609">
                <a target="_blank" href="https://www.instagram.com/kurbensons" className="flex items-center gap-1.5 text-gray-500 hover:text-orange-500 transition-colors" aria-label="Instagram" data-id="element-610">
                  <InstagramIcon className="h-4 w-4" data-id="element-611" />
                  <span className="text-sm" data-id="element-612">kurbensons</span>
                </a>
              </div>
            </div>
          </div>

          {/* Team Member 4 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden group hover:border-orange-500/30 transition-colors" data-id="element-613">
            <div className="aspect-[4/5] overflow-hidden" data-id="element-614">
              <img src="https://cdn.magicpatterns.com/uploads/jpyzu3B7Guw5vc7Wgb1XMq/bb276a1c-4ccd-4256-8a94-17dff99ecac4.jpg" alt="Kārlis Reinfelds" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-615" />
            </div>
            <div className="p-5" data-id="element-616">
              <h3 className="font-bold text-white text-lg" data-id="element-617">Kārlis Reinfelds</h3>
              <p className="text-orange-500 text-sm font-semibold mb-3" data-id="element-618">
                {t('team.member4Role')}
              </p>
              <p className="text-gray-400 text-sm mb-4" data-id="element-619">
                {'Cilv\u0113ks, kur\u0161 p\u0101rv\u0113r\u0161 tehnisko parku par izaicin\u0101jumu, kas sp\u0113j p\u0101rbaud\u012Bt visus nervus un tom\u0113r liek dal\u012Bbniekiem smieties un atgriezties.'}
              </p>
              <div className="flex items-center gap-3" data-id="element-620">
                <a target="_blank" href="https://www.instagram.com/reinfeldc" className="flex items-center gap-1.5 text-gray-500 hover:text-orange-500 transition-colors" aria-label="Instagram" data-id="element-621">
                  <InstagramIcon className="h-4 w-4" data-id="element-622" />
                  <span className="text-sm" data-id="element-623">reinfeldc</span>
                </a>
              </div>
            </div>
          </div>

          {/* Team Member 5 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden group hover:border-orange-500/30 transition-colors" data-id="element-624">
            <div className="aspect-[4/5] overflow-hidden" data-id="element-625">
              <img src="https://cdn.magicpatterns.com/uploads/bxoaDA2nQcsiay98UdKd1s/PHOTO-2026-03-03-17-29-27.jpg" alt="Rolands Indriksons" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-626" />
            </div>
            <div className="p-5" data-id="element-627">
              <h3 className="font-bold text-white text-lg" data-id="element-628">
                Rolands Indriksons
              </h3>
              <p className="text-orange-500 text-sm font-semibold mb-3" data-id="element-629">
                {t('team.member5Role')}
              </p>
              <p className="text-gray-400 text-sm mb-4" data-id="element-630">
                {t('team.member5Desc')}
              </p>
              <div className="flex items-center gap-3" data-id="element-631">
                <a target="_blank" href="https://www.instagram.com/rolands.indriksons" className="flex items-center gap-1.5 text-gray-500 hover:text-orange-500 transition-colors" aria-label="Instagram" data-id="element-632">
                  <InstagramIcon className="h-4 w-4" data-id="element-633" />
                  <span className="text-sm" data-id="element-634">rolands.indriksons</span>
                </a>
              </div>
            </div>
          </div>

          {/* Team Member 6 */}
          <div className="bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden group hover:border-orange-500/30 transition-colors" data-id="element-635">
            <div className="aspect-[4/5] overflow-hidden" data-id="element-636">
              <img src="https://cdn.magicpatterns.com/uploads/fLDxyPkUcE9BLXLZW79epZ/PHOTO-2026-03-03-17-19-31.jpg" alt="Jānis Jurgelevičs" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-637" />
            </div>
            <div className="p-5" data-id="element-638">
              <h3 className="font-bold text-white text-lg" data-id="element-639">
                Jānis Jurgelevičs
              </h3>
              <p className="text-orange-500 text-sm font-semibold mb-3" data-id="element-640">
                {t('team.member6Role')}
              </p>
              <p className="text-gray-400 text-sm mb-4" data-id="element-641">
                {t('team.member6Desc')}
              </p>
              <div className="flex items-center gap-3" data-id="element-642">
                <a target="_blank" href="https://www.instagram.com/jeinovich" className="flex items-center gap-1.5 text-gray-500 hover:text-orange-500 transition-colors" aria-label="Instagram" data-id="element-643">
                  <InstagramIcon className="h-4 w-4" data-id="element-644" />
                  <span className="text-sm" data-id="element-645">jeinovich</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Sponsors Section */}
        <div className="text-center mb-12" data-id="element-646">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-[0.3em] mb-3" data-id="element-647">
            {t('team.makingPossible')}
          </p>
          <h3 className="font-display text-3xl md:text-4xl tracking-wider text-white mb-4" data-id="element-648">
            {t('team.sponsorsTitle')}
          </h3>
        </div>

        {/* Title Sponsor */}
        <div className="mb-10" data-id="element-649">
          <p className="text-center text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4" data-id="element-650">
            {t('team.titleSponsor')}
          </p>
          <div className="flex justify-center" data-id="element-651">
            <a href="https://www.instagram.com/pirmaisracing_/" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-orange-500/30 rounded-2xl px-12 py-8 flex items-center justify-center hover:border-orange-500/60 transition-colors" data-id="element-652">
              <div className="text-center" data-id="element-653">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-654">
                  <InstagramIcon className="h-8 w-8 text-orange-500" data-id="element-655" />
                  <span className="font-display text-4xl tracking-wider text-white" data-id="element-656">
                    PIRMAIS RACING
                  </span>
                </div>
                <p className="text-gray-500 text-sm" data-id="element-657">
                  {t('team.officialSponsor')}
                </p>
              </div>
            </a>
          </div>
        </div>

        {/* Gold Sponsors */}
        <div className="mb-10" data-id="element-658">
          <p className="text-center text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4" data-id="element-659">
            {t('team.goldSponsors')}
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-660">
            {/* 1. Black Box */}
            <a href="https://www.youtube.com/@BlackBox_Latvija" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-661">
              <img src="https://cdn.magicpatterns.com/uploads/hbGy1HvH9TKCisje22WJeK/QYg6E6Dp.png" alt="Black Box — Latvijas top biznesa podkāsts" className="h-full w-full object-contain p-2" data-id="element-662" />
            </a>
            {/* 2. Mežezers */}
            <a href="https://www.mezezers.lv/lv/" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-663">
              <img src="https://cdn.magicpatterns.com/uploads/ecopGzFurhysGBSQ84vp5S/PHOTO-2026-03-03-19-24-23.jpg" alt="Mežezers atpūtas komplekss" className="h-full w-full object-contain p-2" data-id="element-664" />
            </a>
            {/* 2. TS MTL LTD. */}
            <div className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-665">
              <img src="https://cdn.magicpatterns.com/uploads/grmgNr6QkhdbXLSu5EFf1v/PHOTO-2026-03-03-17-41-45.jpg" alt="TS MTL LTD." className="h-full w-full object-contain p-2" data-id="element-666" />
            </div>
            {/* 3. Karotītes */}
            <a href="https://karotites.lv" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-667">
              <img src="https://cdn.magicpatterns.com/uploads/k2sJa6MhrWyNQZhDryosex/Screenshot_2026-03-08_at_19.47.16.png" alt="Karotītes zemnieku saimniecība" className="h-full w-full object-contain p-2" data-id="element-668" />
            </a>
            {/* 4. AB Brigs */}
            <a href="https://www.facebook.com/brigsab/?locale=lv_LV" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-669">
              <img src="https://cdn.magicpatterns.com/uploads/mmjEzPawkxTz221GUFyScg/Screenshot_2026-03-08_at_22.07.08.png" alt="AB Brigs" className="h-full w-full object-contain p-2" data-id="element-670" />
            </a>
            {/* 6. TRU·FIT */}
            <a href="https://www.trufit.eu/lv/" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-671">
              <img src="https://cdn.magicpatterns.com/uploads/7vMvYoNvDt6exoDYnZWNLV/Screenshot_2026-03-08_at_22.47.19.png" alt="TRU·FIT" className="h-full w-full object-contain p-2" data-id="element-672" />
            </a>
            {/* 6. Moto Mania */}
            <a href="https://www.motomania.store" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-673">
              <img src="https://cdn.magicpatterns.com/uploads/9bvB2P3w4aqycfdgbHk2MX/WhatsApp_Image_2026-03-08_at_22.10.52.jpg" alt="Moto Mania" className="h-full w-full object-contain p-2" data-id="element-674" />
            </a>
            {/* 7. Phil Mycock */}
            <div className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-675">
              <img src="https://cdn.magicpatterns.com/uploads/uPqcVGYPudEVNvMsqifXVi/WhatsApp_Image_2026-03-08_at_15.15.47.jpg" alt="Phil Mycock" className="h-full w-full object-contain p-2" data-id="element-676" />
            </div>
            {/* 8. KK808 */}
            <a href="https://www.instagram.com/kalvkusk/" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-677">
              <img src="https://cdn.magicpatterns.com/uploads/iFhSeznGpPnauZPLxj8JAC/WhatsApp_Image_2026-03-08_at_19.27.53.jpg" alt="KK808" className="h-full w-full object-contain p-2" data-id="element-678" />
            </a>
            {/* 10. ECOM STRIVE */}
            <a href="https://e-komercija.lv" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-679">
              <img src="https://cdn.magicpatterns.com/uploads/aJhGCK8sLp7TH7qcaSpriD/WhatsApp_Image_2026-03-08_at_19.51.02.jpg" alt="ECOM STRIVE" className="h-full w-full object-contain p-2" data-id="element-680" />
            </a>
            {/* 11. Siltie Nami */}
            <a href="https://siltienami.lv" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-681">
              <img src="https://cdn.magicpatterns.com/uploads/1PdRLZ92F1WuCDv7FkMp2C/WhatsApp_Image_2026-03-08_at_15.17.43.jpg" alt="Siltie Nami" className="h-full w-full object-contain p-2" data-id="element-682" />
            </a>
            {/* 10. Mandet */}
            <a href="https://www.mandet.co" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-683">
              <img src="https://cdn.magicpatterns.com/uploads/2iKagQCXnNK6dDhYTqXRB7/Frame_39551.svg" alt="Mandet" className="h-full w-full object-contain p-3" data-id="element-684" />
            </a>
            {/* 11. ToGet Constructions */}
            <a href="https://www.toget.lv" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-685">
              <img src="https://cdn.magicpatterns.com/uploads/x262tJeYgZxeei5AfGngkN/Screenshot_2026-03-08_at_13.53.09.png" alt="ToGet Constructions" className="h-full w-full object-contain p-2" data-id="element-686" />
            </a>
            {/* 12. ToColor */}
            <a href="https://tocolor.lv/lv/" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-687">
              <img src="https://cdn.magicpatterns.com/uploads/qt7RAV9wo7qng2AhZk4cza/Screenshot_2026-03-08_at_13.53.00.png" alt="ToColor" className="h-full w-full object-contain p-2" data-id="element-688" />
            </a>
            {/* 13. Qeeper */}
            <a href="https://qeeper-nordic.com" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-689">
              <img src="https://cdn.magicpatterns.com/uploads/ddUpdSJKGX981GxVQRc5GL/WhatsApp_Image_2026-03-08_at_15.17.43.jpg" alt="Qeeper" className="h-full w-full object-contain p-2" data-id="element-690" />
            </a>
            {/* 14. SmartEco */}
            <a href="http://www.smarteco.lv/" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 rounded-xl overflow-hidden flex items-center justify-center h-24 hover:border-yellow-500/30 transition-colors" data-id="element-691">
              <img src="https://cdn.magicpatterns.com/uploads/eYZH2bymeMS7BTj4vJwQ3V/WhatsApp_Image_2026-04-28_at_21.48.36.jpg" alt="SmartEco" className="h-full w-full object-contain p-2" data-id="element-692" />
            </a>
          </div>
        </div>

        {/* Silver Sponsors */}
        <div data-id="element-693">
          <p className="text-center text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4" data-id="element-694">
            {t('team.silverSponsors')}
          </p>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-3" data-id="element-695">
            <div className="bg-neutral-900/50 border border-neutral-800/50 rounded-lg p-4 flex items-center justify-center h-16 hover:border-gray-500/30 transition-colors" data-id="element-696">
              <span className="font-display text-sm tracking-wider text-gray-500" data-id="element-697">
                KMOTO.LV
              </span>
            </div>
            <div className="bg-neutral-900/50 border border-neutral-800/50 rounded-lg p-4 flex items-center justify-center h-16 hover:border-gray-500/30 transition-colors" data-id="element-698">
              <span className="font-display text-sm tracking-wider text-gray-500" data-id="element-699">
                ZS STRAUTMAĻI
              </span>
            </div>
            <div className="bg-neutral-900/50 border border-neutral-800/50 rounded-lg p-4 flex items-center justify-center h-16 hover:border-gray-500/30 transition-colors" data-id="element-700">
              <span className="font-display text-sm tracking-wider text-gray-500" data-id="element-701">
                SMILTENES NOVADS
              </span>
            </div>
            <div className="bg-neutral-900/50 border border-neutral-800/50 rounded-lg p-4 flex items-center justify-center h-16 hover:border-gray-500/30 transition-colors" data-id="element-702">
              <span className="font-display text-sm tracking-wider text-gray-500" data-id="element-703">
                STORENT
              </span>
            </div>
            <div className="bg-neutral-900/50 border border-neutral-800/50 rounded-lg p-4 flex items-center justify-center h-16 hover:border-gray-500/30 transition-colors" data-id="element-704">
              <span className="font-display text-sm tracking-wider text-gray-500" data-id="element-705">
                KRAFTER
              </span>
            </div>
            <div className="bg-neutral-900/50 border border-neutral-800/50 rounded-lg p-4 flex items-center justify-center h-16 hover:border-gray-500/30 transition-colors" data-id="element-706">
              <span className="font-display text-sm tracking-wider text-gray-500" data-id="element-707">
                BRENGUĻU ALUS
              </span>
            </div>
            <div className="bg-neutral-900/50 border border-neutral-800/50 rounded-lg p-4 flex items-center justify-center h-16 hover:border-gray-500/30 transition-colors" data-id="element-708">
              <span className="font-display text-sm tracking-wider text-gray-500" data-id="element-709">
                AHV DAMBIS
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}